export default {
  orderList: {
    url: '/customerShipmentReplacement/page',
    method: 'post',
    desc: '换货分页接口'
  },
  comments: {
    url: '/customerShipmentReplacement/comments',
    method: 'post',
    desc: '换货备注'
  },
}
